import Icon from '../components/Icon.vue'

Icon.register({
  'address-book': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M436 160C442.6 160 448 154.6 448 148V108C448 101.4 442.6 96 436 96H416V48C416 21.5 394.5 0 368 0H48C21.5 0 0 21.5 0 48V464C0 490.5 21.5 512 48 512H368C394.5 512 416 490.5 416 464V416H436C442.6 416 448 410.6 448 404V364C448 357.4 442.6 352 436 352H416V288H436C442.6 288 448 282.6 448 276V236C448 229.4 442.6 224 436 224H416V160H436zM208 128C243.3 128 272 156.7 272 192S243.3 256 208 256 144 227.3 144 192 172.7 128 208 128zM320 364.8C320 375.4 310 384 297.6 384H118.4C106 384 96 375.4 96 364.8V345.6C96 313.8 126.1 288 163.2 288H168.2C180.5 293.1 193.9 296 208 296S235.6 293.1 247.8 288H252.8C289.9 288 320 313.8 320 345.6V364.8z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/address-book.js
// module id = g8Sd
// module chunks = 144